<template>
  <div class="awardItem">
    <div class="awardIcon">
      <Award :awardData="awardData" />
    </div>
    <div class="main">
      <div class="titleArea">
        <span class="label">{{ labelText }}</span>
        <span class="title">{{ awardData.title }}</span>
      </div>
      <div class="time">{{ timeText }}</div>
      <button
        v-if="awardData.rewardType === 'ENTITY'"
        class="btn"
        @click="handleGoAddressPage"
      >
        {{ btnText }}
      </button>
      <button
        v-else-if="awardData.rewardType === 'COUPON'"
        class="btn"
        @click="handleUseCoupon(awardData)"
      >
        {{ $t('my_awards.use_coupon') }}
      </button>
      <button
        v-else-if="awardData.clickUrl"
        class="btn"
        @click="handleUseAward(awardData)"
      >
        去使用
      </button>
    </div>
  </div>
</template>

<script>
import Award from '@/components/templates/common/awardItem/Award';
import { AWARD_NAME } from '../../constants';
import { toDayDate, urlHandle } from '../../../helper';
import { useCoupon } from '@/components/js/lalaPrize/lalaCoupon';
import { formatTime } from '@/utils';

export default {
  components: { Award },
  props: {
    awardData: {
      type: Object,
      required: true
    },
    actEndTimeStr: {
      type: String,
      required: true
    },
    isHasUserAddress: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    labelText() {
      if (this.awardData.rewardType === 'COUPON') {
        return this.awardData.businessTypeStr;
      }
      return AWARD_NAME[this.awardData.rewardType] || '';
    },
    awardEndTimeStr() {
      if (this.awardData && this.awardData.endTime) {
        return formatTime('M月d日', this.awardData.endTime / 1000);
      }
      return '';
    },
    timeText() {
      switch (this.awardData.rewardType) {
        case 'ENTITY':
          return `请于${this.awardEndTimeStr ||
            this.actEndTimeStr}活动结束前填写收货地址`;
        default:
          if (
            this.awardData &&
            this.awardData.startTime &&
            this.awardData.endTime
          ) {
            return `${this.$t('my_awards.valid_date')}: ${toDayDate(
              this.awardData.startTime,
              this.$t('my_awards.date_format')
            )}-${toDayDate(
              this.awardData.endTime,
              this.$t('my_awards.date_format')
            )}`;
          }
      }
      return '';
    },
    btnText() {
      return this.isHasUserAddress ? '修改地址' : '填写地址';
    }
  },
  methods: {
    handleUseCoupon(award) {
      useCoupon(award.businessType);
    },
    handleUseAward(award) {
      if (award.clickUrl && award.clickUrl.indexOf('huolala.cn') > -1) {
        return urlHandle(award.clickUrl);
      }
      location.href = award.clickUrl;
    },
    handleGoAddressPage() {
      this.$router.push('/contact');
    }
  }
};
</script>

<style lang="less" scoped>
.awardItem {
  margin: 0 auto 24px;
  display: flex;
  padding: 30px 24px;
  background-color: #fff;
  align-items: flex-start;

  .awardIcon {
    flex: 140px 0 0;
    margin-top: 10px;
    margin-right: 32px;
    height: 140px;
    font-size: 32px;
  }

  .main {
    flex-grow: 1;
    min-height: 140px;
    .titleArea {
      max-width: 480px;
      display: inline-block;
      overflow: hidden;

      .label {
        margin-right: 14px;
        padding: 0 10px;
        font-size: 24px;
        color: #ff6600;
        border: 2px solid #ff6600;
        border-radius: 7px;
      }

      .title {
        font-size: 32px;
        color: #262626;
      }
    }

    .time {
      margin-top: 5px;
      height: 38px;
      font-size: 26px;
      color: #8c8c8c;
    }

    .btn {
      margin-top: 15px;
      margin-right: 10px;
      float: right;
      min-width: 160px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: normal;
      font-size: 26px;
      color: #ffffff;
      background: linear-gradient(to top, #ff7e00 0%, #ff9600 39%, #ffb80f 99%);
      border-radius: 24px;
    }
  }
}
</style>
